import { toBrowserPath } from '@shared/config';
import { logger } from '@shared/lib/logger';
import { resetSession } from '@shared/session';

import { normalizeError } from './api-error';
import { clearLegacySession } from './legacy-session';
import { rawClient } from './raw-client';
import { sessionEndpoints } from './session.endpoints';

export interface LogoutOptions {
  /** 로그아웃 뒤 갈 앱 경로. 기본 `/`(기준 경로 아래의 처음) */
  to?: string;
  navigate?: (path: string) => void;
}

/**
 * 로그아웃: 서버 revoke(실패해도 진행) → 세션 리셋 → 하드 네비게이션.
 * 하드 네비게이션으로 메모리에 남은 상태를 한 번에 비운다.
 */
export async function logout(options: LogoutOptions = {}): Promise<void> {
  try {
    await rawClient.request({
      method: sessionEndpoints.logout.method,
      url: sessionEndpoints.logout.path,
    });
  } catch (caught) {
    const error = normalizeError(caught);
    logger.warn('로그아웃 요청이 실패했습니다. 로컬 세션은 정리합니다', {
      ...(error.traceId ? { traceId: error.traceId } : {}),
      code: error.code,
    });
  }

  // 구 웹 토큰이 남아 있으면 다음 부팅에서 다시 이어받는다(DD-88)
  clearLegacySession();
  resetSession();
  const navigate =
    options.navigate ?? ((path: string) => window.location.assign(toBrowserPath(path)));
  navigate(options.to ?? '/');
}
